<template>

<div>
    
    <div class='row mt-4' v-if='!isReady'>
        <div class='col-12 text-center'>
            <img src='/resources/loader.svg' width="75px">
        </div>
    </div>

    <div class="row mt-4" v-if='isReady'>
        <div class="col-12 d-flex flex-wrap justify-content-center justify-content-sm-start">
            <div v-for='i in images' 
                 :class="['img-thumb-fluid']">
                
                <a data-fancybox="gallery-1" 
                   :href="i.url" class="img-thumb">
                   
                    <span class="img-overway">
                        <span class="icon icon-zoom-in"></span>
                    </span>
                    <img :src="i.url_thumb" alt="Free Onlyfans Galleries" class="img-fluid">
                </a>

            </div>

        </div>
    </div>
</div>
</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        props : ['m', 'mn'],

        created() {
           
        },

        data() {
            return {

                isReady : false,

                images : [],

            }
        },

        methods : {

            getData() {

                this.ajax.call('mdl:sg', { m : this.m }, (r) => {

                    if( r.status == 'success' ) {
                        
                        this.images = r.data;
                        this.isReady = true;

                    }

                })
            }

        }  

    }
</script>
